import { GQL_DOMAIN } from "@launchos/shared-utils/env";

type ResetResult = { statusCode: number; message: string; response?: { name?: string } | null };

const FAILED: ResetResult = { statusCode: 500, message: "Something went wrong. Please try again." };

const gql = async (query: string, variables: Record<string, string>, field: string): Promise<ResetResult> => {
  try {
    const response = await fetch(GQL_DOMAIN, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, variables }),
    });
    const json = await response.json();
    return json?.data?.[field] || FAILED;
  } catch (err) {
    return FAILED;
  }
};

/** Emails a reset link if the address has an account. Same answer either way. */
export const requestPasswordReset = (to: string) =>
  gql(
    `mutation ($to: String!) { sendResetPasswordEmail(to: $to) { statusCode message } }`,
    { to },
    "sendResetPasswordEmail"
  );

/** Checks a reset link before showing the form. */
export const checkResetLink = (token: string) =>
  gql(
    `query ($token: String!) { verifyToken(token: $token) { statusCode message response } }`,
    { token },
    "verifyToken"
  );

/** Sets the new password using the code from the email. */
export const setNewPassword = (token: string, password: string) =>
  gql(
    `mutation ($token: String!, $password: String!) { resetPassword(token: $token, password: $password) { statusCode message } }`,
    { token, password },
    "resetPassword"
  );
